import $ from "jquery";
import gsap from 'gsap';
import imagesLoaded from 'imagesloaded';

export default class Preload {
    constructor() {
        this.progress = {
            bar: document.querySelector('#app-loader .loading-progress'),
        }

        this.preloader = document.getElementById('app-loader');

        this.loadedCount = 0;
        this.loadingProgress = 0;
    }

    init() {
        this.preload();
        // this.simplePreload();
    }

    preload() {
        $('body').addClass('overflow-hidden');
        const preloader = $('#app-loader');

        var imgLoad = imagesLoaded( 'body' );
        imgLoad.on( 'progress', function(instance, image){
            var result = image.isLoaded ? 'loaded' : 'broken';

            // console.log( 'image is ' + result + ' for ' + image.img.src );
            // preloader.addClass('active');
            setTimeout(function(){
                // preloader.remove();
            }, 1500);   
        });

        imgLoad.on( 'always', function(){
            console.log('Tutte caricate!')

            if(document.querySelector('.page-blog')){
                console.log('funzia');
                window.scroll({
                    top: 1,
                    behavior: 'smooth' 
                });
            }

            preloader.addClass('active');
            $('body').removeClass('overflow-hidden');
            setTimeout(function(){
                preloader.remove();
            }, 1500);
        });
    }

    // init() {
    //     if (app.loading === false) return;
    //     setTimeout(() => {
    //         this.set();
    //     }, 500);
    // }

    // destroy = () => {
    //     app.loading = false;
    //     app.loader = undefined;
    //     setTimeout(() => {
    //         this.section.preloader.remove();
    //     }, 1000);
    // }

    // set = () => {
    //     gsap.set(this.progress.bar, {
    //         width: 0,
    //     });

    //     // gsap.set(this.page, {
    //     //     y: window.innerHeight / 2,
    //     // });

    //     // gsap.to(this.section.preloader, 2,{
    //     //     ease: 'expo.inOut',
    //     //     y: -window.innerHeight,
    //     // }, 2.5);

    //     // gsap.to(this.page, 2,{
    //     //     y: 0,
    //     //     ease: 'expo.inOut',
    //     // }, 2.5);

    //     // gsap.to(this.overlay, 2,{
    //     //     autoAlpha: 0,
    //     //     onComplete: () => {
    //     //         this.destroy();
    //     //         // app.scroll.resize();
    //     //     },
    //     // },2.5);
    // }
}
